export default {"src":"/_next/static/media/furniture.a46aa653.gif","height":425,"width":512,"blurWidth":0,"blurHeight":0};